module.exports = __webpack_public_path__ + "img/water-background.3fe177ae.webp";